import dynamic from "next/dynamic";

const Templates = {
    estandar: dynamic(() => import("@/shared/Layout/Estandar")),
    destacada: dynamic(() => import("@/shared/Layout/Destacada")),
    destacadaPlus: dynamic(() => import("@/shared/Layout/DestacadaPlus")),
    DestacadaExtra: dynamic(() => import("@/shared/Layout/DestacadaExtra")),
    Recipes: dynamic(() => import("@/shared/Layout/Recipes")),
};

export default Templates;